import { useEffect } from "react";

export const useSafariViewPortReset = () => {
  const resetSafariViewport = () => {
    const viewportmeta = document.querySelector("meta[name=viewport]");
    viewportmeta?.setAttribute("content", "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0");
  };

  useEffect(() => {
    resetSafariViewport();
  }, []);
};
